import React from 'react';
import {
  Dialog,
  useTheme,
  useMediaQuery,
  DialogActions,
  Button,
  DialogProps,
  CircularProgress,
  makeStyles,
} from '@material-ui/core';

import { Content } from './styles';

interface CancelConfirmProps extends DialogProps {
  question?: boolean;
  haveCustomButton?: boolean;
  buttonNegative?: string;
  buttonPositive?: string;
  buttonCustom?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  onCustom?: () => void;
  disabledConfirmButton?: boolean;
  loadingConfirmButton?: boolean;
  disabledCustomButton?: boolean;
  loadingCustomButton?: boolean;
  contentFlex?: boolean;
  contentAlign?: React.CSSProperties['alignItems'];
  hasContent?: boolean;
}

const Modal = ({
  onConfirm,
  onCancel,
  onCustom,
  question,
  haveCustomButton,
  buttonNegative,
  buttonPositive,
  buttonCustom,
  children,
  disabledConfirmButton,
  loadingConfirmButton,
  disabledCustomButton,
  loadingCustomButton,
  contentFlex,
  contentAlign,
  hasContent = true,
  ...props
}: CancelConfirmProps) => {
  const useStyles = makeStyles(() => ({
    contentFlex: {
      display: 'flex',
    },
    contentAlign: {
      alignItems: contentAlign,
    },
    contentFlexAlign: {
      display: 'flex',
      alignItems: contentAlign,
    },
  }));

  const theme = useTheme();
  const classes = useStyles();

  const fullscreen = useMediaQuery(theme.breakpoints.down('xs'));

  const handleConfirm = () => {
    if (loadingConfirmButton) {
      return;
    }

    onConfirm();
  };

  const handleCustom = () => {
    if (loadingCustomButton) {
      return;
    }

    onCustom && onCustom();
  };

  return (
    <Dialog
      maxWidth='xl'
      fullScreen={fullscreen}
      disableScrollLock={true}
      onClose={_ => onCancel && onCancel()}
      {...props}
    >
      {hasContent ? (
        <Content
          className={
            contentFlex && contentAlign
              ? classes.contentFlexAlign
              : contentFlex
              ? classes.contentFlex
              : classes.contentAlign
          }
        >
          {children}
        </Content>
      ) : (
        children
      )}

      <DialogActions style={{ justifyContent: 'center' }}>
        {question && (
          <Button
            autoFocus
            variant='contained'
            color='secondary'
            style={{ textTransform: 'none' }}
            onClick={_ => onCancel && onCancel()}
          >
            {buttonNegative ?? 'Cancelar'}
          </Button>
        )}
        {haveCustomButton && (
          <Button
            autoFocus
            variant='contained'
            color='secondary'
            style={{ textTransform: 'none' }}
            onClick={handleCustom}
            disabled={disabledCustomButton}
          >
            {loadingCustomButton ? <CircularProgress size={26} /> : buttonCustom ?? 'Não'}
          </Button>
        )}
        <Button
          autoFocus
          variant='contained'
          color='secondary'
          style={{ textTransform: 'none' }}
          onClick={handleConfirm}
          disabled={disabledConfirmButton}
        >
          {loadingConfirmButton ? <CircularProgress size={26} /> : buttonPositive ?? (question ? 'Sim' : 'OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
